package com.wintermar.inspection.util

enum class EncryptType(val transformation: String) {
    APP("AES/CBC/PKCS7Padding"), //TODO: will change to AES/GCM/NoPadding later
    WEB("AES-CBC"), //TODO: will change to AES-GCM later
    DESKTOP("AES/CBC/PKCS5Padding") //TODO: will change to AES/GCM/NoPadding later
}
